export class LoginUser {
    constructor(
        public readonly id: number,
        public readonly token: string,
    ) {}
}
